// BFF: ○ gap — legacy programs and programsPeopleEnrollment. The tab has no bff/crm module.
export { default } from './ProgramTab'
